import { useMemo } from "react";

import type { FilterType } from "@/components/@types";
import { useLayoutReportFilterDefinitions } from "@/app/app/_/views/ReportsView/reportFilterDefinitions.hooks";
import { getSharedReportFilterDefinitions } from "@/app/share/report/sharedFilterDefinitions";
import {
  buildSharedEntityOptions,
  editableSharedFilters,
  editableSharedGlobalFilterKeys,
} from "@/app/share/report/sharedReportFilters";
import type { SharedViewLayout } from "@/app/share/report/sharedReportTypes";
import { UtilityBar } from "@/components/organisms/UtilityBar";

export function SharedReportFilterBar({
  layout,
  filters,
  onFiltersChange,
}: {
  layout: SharedViewLayout;
  filters: FilterType[];
  onFiltersChange: (filters: FilterType[]) => void;
}) {
  const entities = useMemo(() => buildSharedEntityOptions(layout), [layout]);
  const editableFilters = useMemo(
    () => editableSharedFilters(filters),
    [filters],
  );
  const layoutFilterDefinitions = useLayoutReportFilterDefinitions();
  const filterDefinitions = useMemo(() => {
    const editableKeys = editableSharedGlobalFilterKeys(layout);
    const all = getSharedReportFilterDefinitions(
      entities,
      layoutFilterDefinitions,
    );
    return Object.fromEntries(
      Object.entries(all).filter(([key]) => editableKeys.has(key)),
    );
  }, [entities, layout, layoutFilterDefinitions]);

  if (Object.keys(filterDefinitions).length === 0) {
    return null;
  }

  return (
    <UtilityBar
      includeSort={false}
      disablePadding
      compactFilters
      filters={editableFilters}
      filterDefinitions={filterDefinitions}
      onFiltersChange={onFiltersChange}
    />
  );
}
